import { Crown } from 'lucide-react';
import type { ReactElement } from 'react';
import { cn } from '@/helpers/utils';

const OPTIONS = ['Haaland', 'Salah', 'Palmer', 'Saka'] as const;
const PICKED = 'Salah';

export function CaptainPreview(): ReactElement {
  return (
    <div className="rounded-2xl border border-border bg-card p-4 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10px] uppercase tracking-wide text-muted-foreground font-semibold">Captain</div>
        <div className="inline-flex items-center gap-1 text-[10px] text-muted-foreground/70 font-normal">
          <Crown className="h-3 w-3" /> Your pick
        </div>
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {OPTIONS.map((name) => {
          const active = name === PICKED;
          return (
            <div
              key={name}
              className={cn(
                'rounded-lg border px-1.5 py-2.5 text-center',
                active ? 'border-gold bg-gold/15' : 'border-border bg-muted/30',
              )}
            >
              <div
                className={cn(
                  'truncate',
                  active ? 'text-sm font-extrabold text-foreground' : 'text-xs font-medium text-muted-foreground',
                )}
              >
                {name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
